import { PencilIcon, TrashIcon } from "@heroicons/react/20/solid";
import ContributorResponseResource from "common/resources/Project/Config/Contributor/ContributorResponseResource";
import Typography from "components/elements/Typography";
import DefaultAvatar from "assets/images/default-avatar.svg";
import classes from "./classes.module.scss";
import { useContributor } from "components/pages/ProfessionalSpace/hooks/useContributor";

type IProps = {
	contributor: ContributorResponseResource;
	onEdit: () => void;
	onDelete: () => void;
};

export default function RoleMember(props: IProps) {
	const { avatarUrl } = useContributor(props.contributor);

	return (
		<div className={classes["root"]}>
			<div className={classes["member-info"]}>
				<img src={avatarUrl ?? DefaultAvatar} alt={`${props.contributor.firstName} ${props.contributor.lastName}`} className={classes["avatar"]} />
				{(props.contributor.firstName || props.contributor.lastName) && (
					<>
						<Typography type="p" weight="regular" size="small" className={classes["name"]}>
							{props.contributor.firstName}
						</Typography>
						<Typography type="p" weight="regular" size="small" className={classes["name"]}>
							{props.contributor.lastName}
						</Typography>
					</>
				)}
				{props.contributor.companyName && (
					<Typography type="p" weight="regular" size="small" className={classes["company-name"]}>
						{props.contributor.companyName}
					</Typography>
				)}
			</div>

			<div className={classes["buttons-container"]}>
				<PencilIcon className={classes["icon"]} onClick={props.onEdit} />
				<TrashIcon className={classes["icon"]} onClick={props.onDelete} />
			</div>
		</div>
	);
}
